<template>
    <div>
        <div class="rules__header"
             v-if="!isRemovedRule() && (!is404 && (sections[0] || isRemovedPage || popups.addRule.show) && isSearch && !isLoadItems && $store.getters['rules/getItems'].length !== 0  || !isSearch && !is404 && !emptyTopSection || isRemovedPage || !sections[0] && popups.addRule.show)">
            <div class=" text-bold rules__header-wrapper" :class="{'text-size-18':!popups.addRule.show}">
                <div v-if="!isRemovedPage" class="rules__header-left">
                    <template v-if="isSearch && !isLoadItems && $store.getters['rules/getItems'].length !== 0">
                        <div class="text-size-l text-bold search-result" v-if="!popups.ruleDetail.show">
                            <span class="i i-search2 mr8"></span>Результаты поиска «<span class="query"
                                                                                          @click="openSearchField">{{ searchStr }}</span>»
                        </div>
                        <div class="text-size-l text-bold search-result back" @click="back" v-else>
                            <span class="i i-arrow mr8" style="top: 5px;"></span>Результаты поиска <span
                                class="text-color">«</span><span class="query"
                                                                 @click="openSearchField">{{ searchStr }}</span><span
                                class="text-color">»</span>
                        </div>
                    </template>

                    <template v-else>
                        <span v-if="topSections[0]" class="ts-name text-size-18">{{ activeTopSectionName }}</span>
                        <span class="rule-removed text-color-red2"
                              v-if="popups.addRule.show && item.id && !item.active">правило удалено</span>
                    </template>
                </div>
                <div class="rules__header-right" v-if="!isSearch" :class="{'--add-rule': popups.addRule.show}">
                    <template v-if="!isSearch && !isRemovedPage">
                        <span class="ss-name" @click="scrollToUp"
                              v-if="!popups.ruleDetail.show && !popups.addRule.show">{{ activeSectionName }} {{ activeSubSectionName ? '/' : '' }} {{ activeSubSectionName }}</span>
                        <span class="ss-name back" @click="back(true)" v-else-if="!popups.addRule.show">
                              <span class="i i-arrow mr8"></span>
                              {{ activeSectionName }} {{ activeSubSectionName ? '/' : '' }} {{ activeSubSectionName }}
                        </span>
                    </template>
                    <div v-if="isRemovedPage">
                        <span class="back" @click="back" v-if="popups.ruleDetail.show">
                            <span class="i i-arrow mr8"></span>
                            Удаленные
                        </span>
                        <span v-else>Удаленные</span>
                    </div>
                    <div class="btns rule-detail__btns" v-if="popups.ruleDetail.show && !popups.addRule.show">
                        <span class="copy editor-btn has-hover has-hint mr8" v-if="!isRemovedPage"
                            @click.stop="copyRule($event, rule)">
                            <span class="i-wrapper">
                                <span class="i i-copy4"></span>
                                <span class="i i-copy4-active actv"></span>
                                <span class="i i-ok3"></span>
                            </span>
                            <span class="hint bottom-center-direction">Скопировать ссылку</span>
                        </span>
                        <span class="recover editor-btn hover has-hint mr8" @click="openRecover(rule)"
                                  v-if="isRemovedPage">
                            <span class="i-wrapper">
                                <span class="i i-recover"></span>
                            </span>
                          <span class="hint bottom-center-direction">Восстановить</span>
                        </span>
                        <span class="remove editor-btn has-hint has-hover mr8"
                                  v-if="(getRights(rule) === 'W' && !rule.finally) || user.access_rights.is_owner || getRights(rule) === 'C'"
                                  @click.stop="openRemoveRule(rule)">
                            <div class="has-hint">
                                <span class="i-wrapper">
                                    <span class="i i-trash6"></span>
                                    <span class="i i-trash6-active actv"></span>
                                </span>
                                <span class="hint bottom-center-direction">Удалить правило</span>
                            </div>
                        </span>
                        <div v-if="(getRights(rule) === 'W'  && !rule.finally)  && !isRemovedPage || (user.access_rights.is_owner || getRights(rule) === 'C') && !isRemovedPage"
                                 class="edit editor-btn has-hover has-hint" @click="openEditRule(rule)">
                            <span class="i-wrapper">
                                <span class="i i-pencil"></span>
                                <span class="i i-pencil-active actv"></span>
                            </span>
                            <span class="hint bottom-center-direction">Редактировать</span>
                        </div>
                    </div>

                    <div class="btns" v-if="this.popups.addRule.show"
                         :class="{'is-admin': user.access_rights.is_owner || getRights(rule) === 'C'}">
                        <span class="editor-btn mr4 has-hint" @click="editor.commands.bold"
                              :class="{ 'is-active': editor.isActive.bold() }">
                            <span class="i-wrapper">
                                <span class="i i-bold"></span>
                            </span>
                            <span class="hint bottom-center-direction">Жирный</span>
                        </span>
                        <span class="editor-btn mr4 has-hint" @click="giveCommand(editor.commands.bullet_list, 'bullet_list')"
                              :class="{ 'is-active': editor.isActive.bullet_list() }">
                            <span class="i-wrapper">
                                <span class="i i-marker-list"></span>
                            </span>
                            <span class="hint bottom-center-direction">Список с буллитами</span>
                        </span>
                        <span class="editor-btn mr4 has-hint" @click="giveCommand(editor.commands.ordered_list, 'ordered_list')"
                              :class="{ 'is-active': editor.isActive.ordered_list() }">
                            <span class="i-wrapper">
                                <span class="i i-list"></span>
                            </span>
                            <span class="hint bottom-center-direction">Список с номерами</span>
                        </span>
                        <span class="editor-btn mr4 has-hint" @click="giveCommand('h1', 'h1')"
                              :class="{ 'is-active': editor.isActive.heading({ level: 2 }) }">
                            <span class="i-wrapper text-size-ms">
                                H1
                            </span>
                            <span class="hint bottom-center-direction">Большой заголовок</span>
                        </span>
                        <span class="editor-btn mr4 has-hint" @click="giveCommand('h2', 'h2')"
                              :class="{ 'is-active': editor.isActive.heading({ level: 3 }) }">
                            <span class="i-wrapper text-size-ms">
                                H2
                            </span>
                            <span class="hint bottom-center-direction">Малый заголовок</span>
                        </span>
                        <span class="editor-btn mr4 has-hint" @click="giveCommand('h3', 'h3')"
                              :class="{ 'is-active': editor.isActive.heading({ level: 4 }) }">
                            <span class="i-wrapper text-size-ms">
                                H3
                            </span>
                            <span class="hint bottom-center-direction">Малый заголовок</span>
                        </span>
                        <span class="editor-btn mr4 has-hint hover" @click="giveCommand(editor.commands.blockquote, 'blockquote')"
                              :class="{'is-active': editor.isActive.blockquote(), 'mr16 border-right': !(user.access_rights.is_owner || user.access_rights.is_tech_writer) }">
                            <span class="i-wrapper">
                                <span class="i i-quote"></span>
                            </span>
                            <span class="hint bottom-center-direction">Акцент</span>
                        </span>
						<span class="editor-btn mr16 border-right has-hint hover" @click="giveCommand(editor.commands.commentBlock, 'commentBlock')"
                              :class="{'is-active': editor.isActive.commentBlock() }" v-if="user.access_rights.is_owner || user.access_rights.is_tech_writer">
                            <span class="i-wrapper">
                                <span class="i i-comm"></span>
                            </span>
                            <span class="hint bottom-center-direction">Комментарий</span>
                        </span>
                        <span class="editor-btn mr8 has-hint has-hover" @click.stop="openAddLinkPopup">
                                <span class="i-wrapper">
                                    <span class="i i-link5"></span>
                                    <span class="i i-link5-active actv"></span>
                                </span>
                                <span class="hint bottom-center-direction">Вставить ссылку</span>
                        </span>
                        <span class="editor-btn mr8 has-hint has-hover" @click.stop="openAddVideoPopup">
                            <span class="i-wrapper">
                                <span class="i i-video2"></span>
                                <span class="i i-video2-active actv"></span>
                            </span>
                            <span class="hint bottom-center-direction">Вставить видео</span>
                        </span>
                        <span class="editor-btn mr8 has-hint has-hover" @click.stop="openInput()">
                                <span class="i-wrapper">
                                    <span class="i i-file-plus"></span>
                                    <span class="i i-file-plus-active actv"></span>
                                </span>

                                <span class="hint bottom-center-direction">Вставить файл</span>
                        </span>
                        <span class="editor-btn mr16 has-hint has-hover border-right" @click.stop="openInputSchema()">
                            <span class="i-wrapper">
                                <span class="i i-scheme"></span>
                                <span class="i i-scheme-active actv"></span>
                            </span>

                            <span class="hint bottom-center-direction">Вставить блок-схему</span>
                        </span>
                    </div>
                    <div class="has-hint tumbler__zoom" v-if="popups.ruleDetail.show && !popups.addRule.show">
                        <tumbler
                                :name="tumblers.zoom.name"
                                :value="tumblers.zoom.value"
                                :icon="'i i-zoom'"
                        >
                        </tumbler>
                        <span class="hint bottom-center-direction">Увеличить изображения</span>
                    </div>
                    <div class="has-hint tumbler__screencast" v-if="popups.ruleDetail.show && !popups.addRule.show && (user.access_rights.is_owner || user.is_chef || user.access_rights.is_tech_writer )">
                        <tumbler
                                @change="setScreencast()"
                                :name="tumblers.screencast.name"
                                :value="tumblers.screencast.value"
                                :icon="'i i-monitor'"
                        >
                        </tumbler>
                        <span class="hint bottom-center-direction">Добавить в скринкасты</span>
                    </div>

                    <div v-if="popups.ruleDetail.show && !popups.addRule.show" class="rule-detail__right">
                        <div class="locked" v-if="rule.finally && !(curTopSection && curTopSection.rights == 'R')">
                            <span class="i i-lock5"></span>
                        </div>
                        <template v-if="rule.ruleType">
                            <tooltip
                                    :is-btn-close="false"
                                    :add-style="{width: 424 + 'px'}"
                                    :direction="'bottom-right-direction'">
							<span slot="tooltipBtn">
								<div class="rule-type" :class="ruleColor(rule.ruleType)">
									{{ ruleTypeName(rule.ruleType) }}
								</div>
							</span>

                                <div slot="tooltipContent">
                                    <div class="rule-types">
                                        <div class="text-size-l text-bold mb12">
                                            Типы правил
                                        </div>
                                        <div class="item" :class="{'active': rule.ruleType == 1}">
                                            <div class="rule-type --blank">
                                                заготовка
                                            </div>
                                            <div class="text-italic text-color-grey text-size-xs">
                                                Заметка, которая создана обычным пользователем.
                                            </div>
                                        </div>
                                        <div class="item" :class="{'active': rule.ruleType == 2}">
                                            <div class="rule-type --draft">
                                                черновик
                                            </div>
                                            <div class="text-italic text-color-grey text-size-xs">
                                                Правило, над которым работает технический писатель.
                                            </div>
                                        </div>
                                        <div class="item" :class="{'active': rule.ruleType == 4}">
                                            <div class="rule-type">
                                                правило
                                            </div>
                                            <div class="text-italic text-color-grey text-size-xs">
                                                Готовый и отредактированный документ.
                                            </div>
                                        </div>
                                        <div class="item" :class="{'active': rule.ruleType == 5}" v-if="user.access_rights.is_owner || user.is_chef || user.access_rights.is_tech_writer">
                                            <div class="rule-type --archive">
                                                архивное
                                            </div>
                                            <div class="text-italic text-color-grey text-size-xs">
                                                Скрытое от общего доступа правило
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </tooltip>
                        </template>

                        <div class="number">
                            #{{ rule.id }}
                        </div>
                    </div>

                    <div class="tumblers" v-if="popups.addRule.show">
                        <div class="has-hint tumbler__lock"
                             v-if="(user.access_rights.is_owner || (curTopSection && user.is_chef))">
                            <tumbler
                                    :name="tumblers.finally.name"
                                    :value="tumblers.finally.value"
                                    :icon="'i i-lock3'"
                                    @change="isChangeRule = true"
                            >
                            </tumbler>
                            <span class="hint bottom-center-direction">Заблокировать редактирование</span>
                        </div>

                        <div class="has-hint tumbler__notify">
                            <tumbler
                                    :name="tumblers.notify.name"
                                    :value="tumblers.notify.value"
                                    :icon="'i i-notify'"
                                    @change="isChangeRule = true"
                            >
                            </tumbler>
                            <span class="hint bottom-center-direction">Уведомить всех причастных</span>
                        </div>
                    </div>

                    <div class="filter ml16"
                         v-if="(user.access_rights.is_owner || user.access_rights.is_tech_writer) && !popups.ruleDetail.show && !popups.addRule.show && !isSearch && !isRemovedPage">
                        <div class="label">
                            показывать
                        </div>

                        <input-select-new @change="selectedFilterRuleType" :tag="'div'" v-model="filterType.value"
                                          :options="typesSelectOptions" :placeholder="'Тип'"
                                          :list-style="{'max-height': 'none'}"></input-select-new>
                    </div>

                    <div class="has-hint tumbler__editable--bh"
                         v-if="!isLockCurSection && (curTopSection && (curTopSection.rights == 'W' || user.is_chef)) && !popups.addRule.show && !popups.ruleDetail.show && !isShowBottomHeader && !isRemovedPage">
                        <tumbler
                                v-if="user.access_rights.is_owner || (curTopSection && (curTopSection.rights == 'W' || user.is_chef)) && !popups.addRule.show"
                                :name="tumblers.editable.name"
                                :value="tumblers.editable.value"
                                :icon="'i i-pencil2'"
                        >
                        </tumbler>
                        <span class="hint bottom-center-direction">Режим редактирования</span>
                    </div>

                    <div class="rules__btn" @click="openAddRule"
                         v-if="!isRemovedPage && !popups.addRule.show && !popups.ruleDetail.show && !isSearch && !( (isLoadSections || isLoadItems) && isSearchPrev) && isAddRule">
                        <span class="elem">
                            <span class="i i-plus6"></span>
                            Добавить&nbsp;правило
                        </span>
                    </div>
					<div
						v-else-if="!isAddRule && !popups.addRule.show && !popups.ruleDetail.show"
                         class="text-right text-italic text-size-s text-normal text-color-grey df">
                        <span class="i i-inf" style="margin-right: 5px;"></span>Добавлять и редактировать общие правила могут только адмиинистраторы
                    </div>


                    <div class="rules__btn" @click="openRemoveRules" v-if="isRemovedPage && !popups.ruleDetail.show">
                        <span class="elem">
                            <span class="i i-recycle2"></span>
                            Удалить всё
                        </span>
                    </div>


                    <div class="rules__btn-yellow btn btn--ico save"
                         :class="{'load': save.btnType == 'load', 'rules__btn-disabled':!isChangeRule}"
                         v-if="popups.addRule.show" @click="ruleSend">
                        <svg class="btn-preloader mr8">
                            <use xlink:href="@/assets/img/big-icons-sprite.svg#preloader"></use>
                        </svg>
                        <span class="i i-save3 mr8"></span>
                        Сохранить
                    </div>
                    <div class="i i-close10" @click="closeAddRule" v-if="popups.addRule.show"></div>
                </div>
            </div>
        </div>
        <div class="content moderator-rules">
            <div class="rules-left-bg"
                 v-if="popups.ruleDetail.show && isRemovedPage || popups.ruleDetail.show && isSearch || popups.addRule.show && !sections[0]"></div>
            <div class="nothing-block"
                 v-if="emptyTopSection && !popups.addRule.show && !is404 && !isRemovedRule() && !isRemovedPage">
                <div class="nothing-block__wrapper">
                    <svg class="big-icon">
                        <use xlink:href="@/assets/img/big-icons-sprite.svg#folder"></use>
                    </svg>
                    <div class="text-size-l text-color-grey mt16">
                        В этом разделе нет ни одной категории
                    </div>
                    <div class="rules__btn mt16" @click="openRuleCategory"
                         v-if="user.access_rights.is_owner || (curTopSection && (curTopSection.rights == 'W' || user.is_chef)) && !popups.addRule.show">
                <span class="elem">
                    <span class="i i-plus6"></span>
                    Добавить категорию
                </span>
                    </div>
                </div>
            </div>

            <div class="nothing-block" v-if="isSearch && !isLoadItems && $store.getters['rules/getItems'].length === 0">
                <div class="nothing-block__wrapper">
                    <svg class="big-icon">
                        <use xlink:href="@/assets/img/big-icons-sprite.svg#emoji-nothing"></use>
                    </svg>
                    <div class="text-size-l text-color-grey mt16">
                        По запросу «{{ searchStr }}» ничего не найдено
                    </div>
                    <div class="rules__btn mt16" @click="openSearchField">
                    <span class="elem">
                        Изменить запрос
                    </span>
                    </div>
                </div>

            </div>
            <div class="nothing-block nothing-block__404" v-if="is404">
                <div class="nothing-block__wrapper">
                    <svg class="big-icon">
                        <use xlink:href="@/assets/img/big-icons-sprite.svg#emoji-nothing"></use>
                    </svg>
                    <div class="text-size-l text-color mt16 text-bold">
                        Ошибка 404 – Страница не найдена
                    </div>
                </div>
            </div>
            <div class="nothing-block nothing-block__404" v-if="isRemovedRule()">
                <div class="nothing-block__wrapper">
                    <svg class="big-icon" style="height: 48px">
                        <use xlink:href="@/assets/img/big-icons-sprite.svg#recycle-car"></use>
                    </svg>
                    <div class="text-size-l text-color mt16 text-color-grey">
                        Правило удалено
                    </div>
                </div>
            </div>
            <div class="container" v-if="!isRemovedRule()">
                <div class="aside-sticky-block --full-height" v-if="!isRemovedPage && !isSearch && !is404 && !isRemovedRule()">
                    <aside class="aside aside--left aside--catalog"
                           :class="{'aside--no-cats': emptyTopSection && !isLoadSections && popups.addRule.show, 'aside--rule-detail': popups.ruleDetail.show}">
                        <rules-sections v-if="topSections[0]" @closedetail="back"></rules-sections>
                        <div class="" v-if="emptyTopSection && !isLoadSections && popups.addRule.show"
                             :key="isLoadSections" :class="{error: catError, 'repeat-error': repeatCatError}">
                            <svg class="big-icon mt24 ml16" style="height: 80px">
                                <use xlink:href="@/assets/img/big-icons-sprite.svg#aside-error"></use>
                            </svg>
                            <span class="ml16">
                                Чтобы добавить правило в этот<br>
                                раздел, сначала создайте в нём<br>
                                хотя бы одну категорию
                            </span>
                        </div>
                    </aside>
                </div>
                <aside-sticky :marginTop="isShowBottomHeader ? 120 : 88" :marginBottom="32"
                              v-else-if="popups.ruleDetail.show" :key="isRemovedPage">
                    <aside class="aside aside--left aside--catalog aside-removed-rules"
                           v-if="isRemovedPage && popups.ruleDetail.show">
                        <svg class="big-icon mt24 ml16" style="height: 80px">
                            <use xlink:href="@/assets/img/big-icons-sprite.svg#recycle-trash"></use>
                        </svg>
                        <span class="ml16">
                          Удалённые правила можно восстановить или удалить окончательно
                      </span>
                    </aside>
                    <aside class="aside aside--left aside--catalog aside--no-cats"
                           v-else-if="isSearch && popups.ruleDetail.show">
                        <svg class="big-icon mt24 ml16" style="height: 80px">
                            <use xlink:href="@/assets/img/big-icons-sprite.svg#aside-search"></use>
                        </svg>
                        <span class="ml16">
                          С найдеными правилами можно<br>
                          работать, как обычно...
                        </span>
                    </aside>
                </aside-sticky>
                <div class="container__full container-scroll container__right"
                     :class="{'container__rule-edit': popups.addRule.show, 'container__removed-page': isRemovedPage || isSearch, 'container__rule-detail-page': isRemovedPage && popups.ruleDetail.show || isSearch && popups.ruleDetail.show || emptyTopSection && popups.addRule.show && !isLoadSections}"
                     v-if="sections[0]  || sectionsLock[0] || isRemovedPage || popups.addRule.show">
                    <add-rule @change="isChangeRule = true" @load="saveLoading" @scroll="setScrollId"
                              :show="popups.addRule.show" v-if="popups.addRule.show" :editor="editor" :focused="focused"
                              :inputText="inputText" @close="removeContent" ref="addRule"></add-rule>

                    <rules-list v-if="(sections[0] || $route.params.subid || isRemovedPage) && closeSearch"
                                @openeditrule="isChangeRule = false" :filterType="filterType"
								@openAddRule="openAddRule"
                                v-show="(sections[0] || isSearch || sectionsLock[0]) && !popups.addRule.show && !popups.ruleDetail.show  || isRemovedPage && !popups.addRule.show && !popups.ruleDetail.show"
                                :isErrorPage="is404"></rules-list>

                    <transition name="slide">
                        <rule-detail :show="popups.ruleDetail.show"
                                    ref="ruleDetail"
                                     v-show="popups.ruleDetail.show && !popups.addRule.show"/>
                    </transition>
                </div>
            </div>

            <editor-menu-bar :editor="editor" v-slot="{ commands }" v-if="popups.addRule.show">
                <div>
                    <popup :show="popups.addScreenShot.show" :name="popups.addScreenShot.name"
                           @close="screenShotLink.value = ''" :width="400">
                        <div>
                            <div class="text-size-l text-bold text-color mb24">Вставить скриншот</div>
                            <div class="full">
                                <input-styled
                                        :auto-focus="true"
                                        ref="screenShotLink"
                                        name="category"
                                        :placeholder="'Название категории'"
                                        :placeholderInput="'ССЫЛКА LIGHTSHOT ИЛИ YANDEX'"
                                        @enter="addScreenShot(commands)"
                                        v-model="screenShotLink.value"
                                        @focus="screenShotLink.error=false"
                                        :error-text="screenShotLink.value.length > 0 ? 'Для скриншотов используйте сервисы lightshot или yandex' : ''"
                                        :is-error="screenShotLink.error">
                                </input-styled>
                            </div>
                            <div class="row-b mt24">
                                <div class="row-b__col elem-pos-fix mr24">
                                    <submit-btn class="btn" ref="screenShotLinkBtn"
                                                @click.native="addScreenShot(commands)" :type="screenShotLink.btnType">
                                        <span class="i i-ok7 mr8" v-if="screenShotLink.btnType === 'normal'"></span>Готово
                                    </submit-btn>
                                </div>
                            </div>
                        </div>
                    </popup>
                    <popup @close="link.value = ''" :show="popups.addLink.show" :name="popups.addLink.name"
                           :width="400">
                        <div>
                            <div class="text-size-l text-bold text-color mb24">Вставить ссылку</div>
                            <div class="full">
                                <input-styled
                                        :auto-focus="true"
                                        name="addLink"
                                        :placeholder="''"
                                        :placeholderInput="'ССЫЛКА'"
                                        @enter="setLinkUrl(commands)"
                                        v-model="link.value"
                                        @focus="link.error=false"
                                        :error-text="link.value.length > 0 ? 'Используйте ссылку':''"
                                        :is-error="link.error">
                                </input-styled>
                            </div>
                            <div class="row-b mt24">
                                <div class="row-b__col elem-pos-fit mr24">
                                    <submit-btn class="btn" @click.native="setLinkUrl(commands)"
                                                :type="link.btnType">
                                        <span class="i i-ok7 mr8" v-if="link.btnType === 'normal'"></span>Готово
                                    </submit-btn>
                                </div>
                                <div class="row-b__col elem-pos-fix" v-if="link.value">
                                    <a @click="clearLinkUrl(commands)" href="javascript:void(0);"
                                       class="link-icon link-icon__modal">
                                        <span class="i i-trash"></span>
                                        <span class="text">Удалить ссылку</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </popup>
                    <popup :show="popups.addVideo.show" :name="popups.addVideo.name" :width="400">
                        <div>
                            <div class="text-size-l text-bold text-color mb24">Вставить видео</div>
                            <div class="full">
                                <input-styled
                                        :auto-focus="true"
                                        name="category"
                                        :placeholder="''"
                                        :placeholderInput="'ССЫЛКА YOUTUBE'"
                                        @enter="addScreenShot(commands)"
                                        v-model="screenShotLink.value"
                                        @focus="screenShotLink.error=false"
                                        :error-text="screenShotLink.value.length > 0 ? 'Используйте ссылку на видео с YouTube':''"
                                        :is-error="screenShotLink.error">
                                </input-styled>
                            </div>
                            <div class="row-b mt24">
                                <div class="row-b__col elem-pos-fix mr24">
                                    <submit-btn class="btn" @click.native="addScreenShot(commands)"
                                                :type="screenShotLink.btnType">
                                        <span class="i i-ok7 mr8" v-if="screenShotLink.btnType === 'normal'"></span>Готово
                                    </submit-btn>
                                </div>
                            </div>
                        </div>
                    </popup>
                    <input multiple style="opacity: 0;position: absolute; width: 0;" ref="fileInput"
                           @change="onFileAppendEvent(commands, $event)" type="file">
                    <input style="opacity: 0;position: absolute; width: 0;" ref="fileInputSchema"
                           @change="onSchemaAppendEvent(commands, $event)" type="file">
                </div>
            </editor-menu-bar>

            <notify-reset  v-if="popups.isNotifyReset.show"/>
            <rules-popups :recoverItem="recoverItem" @autoSave="ruleSend" @apply="exitWithoutSave"/>

        </div>
    </div>
</template>


<script>
import {mapState} from 'vuex';
import AsideSticky from '@/components/AsideSticky.vue';
import Gallery from '@/components/Gallery.vue';
import Popup from '@/components/modal/Popup.vue';
import AddRule from '@/components/modal/rules/AddRule.vue';
import RuleDetail from '@/components/modal/rules/RuleDetail.vue';
import Tumbler from '@/components/Tumbler.vue';
import RulesPopups from '@/components/RulesPopups.vue';
import RulesSections from '@/components/moderator/Rules/Sections.vue';
import RulesList from '@/components/moderator/Rules/List.vue';
import VueFooter from '@/components/VueFooter.vue';
import InputStyled from '@/components/forms/InputStyled.vue';
import TextareaField from '@/components/forms/TextareaField.vue';
import InputSelect from '@/components/forms/InputSelect.vue';
import SubmitBtn from '@/components/forms/SubmitBtn.vue'
import TextEditorNew from '@/components/editor/TextEditorNew.vue'
import draggable from '@/helpers/vuedraggable.js';
import {Hooper, Slide, Navigation as HooperNavigation} from 'hooper';
import {Editor, EditorContent, EditorMenuBar} from 'tiptap';
import InputSelectNew from '@/components/forms/InputSelectNew.vue';
import Tooltip from '@/components/Tooltip.vue';
import NotifyReset from '@/components/NotifyReset.vue';
import {
    Placeholder,
    History,
    Bold,
    OrderedList,
    BulletList,
    ListItem,
    Italic,
    Heading,
    HorizontalRule,
    Blockquote,
} from 'tiptap-extensions'
import {
    Text,
    Doc,
} from 'tiptap'
import ScreenShot from '@/components/editor/tiptop/screenshot.js';
import CommentBlock from '@/components/editor/tiptop/commentBlock.js';
import {scrollTo} from '@/helpers/animate.js';
import Youtube from '@/components/editor/tiptop/youtube.js';
import HardBreak from '@/components/editor/tiptop/HardBreak.js';
import OtherFile from '@/components/editor/tiptop/OtherFile.js';
import ImagePreloader from '@/components/editor/tiptop/ImagePreloader.js';
import PasteText from '@/components/editor/tiptop/PasteText.js';
import Paragraph from '@/components/editor/tiptop/Paragraph.js';
import Link from '@/components/editor/tiptop/Link.js';
import {copyTextToClipboard} from "@/helpers/util/helper";
import Schema from '@/components/editor/tiptop/schema.js';
import { findSectionById } from '../../helpers/util/helper';

export default {
    metaInfo() {
        return {
            title: 'РЕГЛАМЕНТЫ И ПРАВИЛА',
            titleTemplate: this.$store.state.options.titleTemplate
        }
    },
    name: "Rules",
    components: {
        AsideSticky,
        Gallery,
        AddRule,
        RulesSections,
        RulesList,
        VueFooter,
        InputStyled,
        TextareaField,
        InputSelect,
        SubmitBtn,
        draggable,
        Hooper,
        Slide,
        HooperNavigation,
        TextEditorNew,
        EditorContent,
        EditorMenuBar,
        Popup,
        InputSelectNew,
        Tumbler,
        RuleDetail,
        Tooltip,
        NotifyReset,
        RulesPopups,
    },
    data: function () {
        return {
            ruleType: 0,
            focus: false,
            focused: false,
            search: '',
            isShowedViewer: false,
            inputText: '',
            currentSlide: 1,
            catError: false,
            repeatCatError: false,
            cursorPos: 0,
            tryScroll: 0,
            backToList: false,
            recoverItem: '',
            screenShotLink: {
                value: "",
                error: false,
                btnType: 'normal',
            },
            link: {
                value: "",
                error: false,
                btnType: 'normal',
            },
            save: {
                btnType: 'normal',
            },
            typesOptions: {
                0:{ name: 'все'},
                1: {name: 'заготовка'},
                2: {name: 'черновик'},
                4: {name: 'правило'},
                5: {name: 'архивное'},
            },
			typesSelectOptions: [
                {id: 0, name: 'все'},
                {id: 1, name: 'заготовка'},
                {id: 2, name: 'черновик'},
                {id: 4, name: 'правило'},
                {id: 5, name: 'архивное'},
            ],
            filterType: {
                value: 0,
            },
            scrollID: false,
            newScrollID: null,
            isChangeRule: false,
            appPath: process.env.VUE_APP_PATH_BACK,
            isCurAfterPasteFile: false,
            scrollPositionAfterPasteFile: false,
            editor: new Editor({
                editorProps: {
                    handlePaste: (view, event, slice) => {
                        event.preventDefault();
                        if (event.clipboardData.files.length > 0) {
                            this.isCurAfterPasteFile = true;
                            this.scrollPositionAfterPasteFile = document.documentElement.scrollTop;
                            //event.preventDefault();
                        }
                        if (event.currentTarget == null) {
                            this.isCurAfterPasteFile = false;
                            document.documentElement.scrollTop = this.scrollPositionAfterPasteFile;
                        }
                        return false;
                    },
                },
                extensions: [
                    new HardBreak(),
                    new Text(),
                    new Paragraph(),
                    new Doc(),
                    new History(),
                    new ScreenShot(),
                    new Youtube(),
                    new OtherFile(),
                    new ImagePreloader(),
                    new PasteText(),
                    new Link(),
                    new Bold(),
                    new Blockquote(),
					new CommentBlock(),
                    new Schema(),
                    new Placeholder({
                        emptyEditorClass: 'is-editor-empty',
                        emptyNodeClass: 'is-empty',
                        emptyNodeText: 'Подробно опишите правило',
                        showOnlyWhenEditable: false,
                        showOnlyCurrent: false,
                    }),
                    new OrderedList(),
                    new BulletList(),
                    new ListItem(),
                    new Italic(),
                    new Heading({levels: [2, 3, 4]}),
                    new HorizontalRule(),
                ],
                useBuiltInExtensions: false,
                disableInputRules: true,
                onUpdate: ({getJSON, getHTML}) => {
                    this.divInput(getHTML())
                },
                onFocus: () => {
                    this.divFocus();
                },
                onBlur: () => {
                    this.divBlur();
                },
                onPaste: (view, event, slice) => {
                    event.preventDefault();
                    this.pasteEditor(event);
                    return true;
                },
            }),

        }
    },
    computed: {
        ...mapState({
            popups: state => state.popups.items,
            filterRuleType: state => state.rules.selectedFilterRuleType,
            sections: state => state.rules.sections,
            sectionsLock: state => state.rules.sectionsLock,
            rolled: state => state.rules.rolled,
            topSections: state => state.rules.topSections,
            isLoadItems: state => state.rules.isLoadItems,
            isLoadSections: state => state.rules.isLoadSections,
            isLoadEditRule: state => state.rules.isLoadEditRule,
            cursorPositionObj: state => state.rules.cursorPositionObj,
            useShortcut: state => state.rules.useShortcut,
            hasSelectedSection: state => state.rules.hasSelectedSection,
            canDragState: state => state.rules.canDrag,
            item: state => state.rules.editItem,
            isSearch: state => state.rules.isSearch,
            isSearchPrev: state => state.rules.isSearchPrev,
            user: state => state.users.user,
            searchStr: state => state.rules.searchStr,
            first404: state => state.rules.first404,
            rule: state => state.rules.openedRule,
            scrollTop: state => state.rules.scrollTop,
            tumblers: state => state.rules.tumblers,
            previousSection: state => state.rules.previousSection,
            isEdit: state => state.rules.isEdit,
            closeSearch: state => state.rules.closeSearch,
        }),
		activeCommand(){
			if(this.editor.isActive.bullet_list()){
				return 'bullet_list';
			}else if(this.editor.isActive.ordered_list()){
				return 'ordered_list';
			}else if(this.editor.isActive.heading({ level: 2 }) ){
				return 'h1'
			}else if(this.editor.isActive.heading({ level: 3 }) ){
				return 'h2'
			}else if(this.editor.isActive.heading({ level: 4 }) ){
				return 'h3'
			}else if(this.editor.isActive.blockquote()){
				return 'blockquote'
			}else if(this.editor.isActive.commentBlock()){
				return 'commentBlock'
			}
		},
        isShowBottomHeader() {
            return !this.isStaffPage && this.topSections.length > 3;
        },
        isStaffPage() {
            return this.$route.name === 'moderator-staff' || this.$route.name === 'moderator-staff-detail' || this.$route.name === 'moderator-contacts';
        },
        isSectionDetail() {
            return this.$route.name === 'rules-category-settings'
        },
        canDrag() {
            if (this.user.access_rights.is_owner || (this.curTopSection && (this.curTopSection.rights == 'W' || this.user.is_chef))) {
                return this.canDragState
            } else {
                return false
            }
        },
        isLockCurSection() {
            let result = false;

            for (let i in this.sectionsLock) {
                result = this.activeSubSection === this.sectionsLock[i].id;
                if (result) {
                    break;
                }
            }

            return result;
        },
        activeSection() {
            return this.getActiveSection();
        },
        emptyTopSection() {
            return ((typeof this.sections == 'object' && this.sections.length == 0) || !this.sections) && !this.isLoadSections && this.sectionsLock.length == 0
        },
        activeTopSectionName() {
            let name = '';
            if (this.$route.params.id || this.activeTopSection) {
                let section = this.topSections.find(item => item.id == this.activeTopSection);
                if (section) {
                    name = section.name;
                }
            }
            return name;
        },
        activeTopSectionSubSectionName() {
            let name = '';
            if (this.$route.params.id || this.activeTopSection) {
                let section = this.topSections.find(item => item.id == this.activeTopSection);
                if (section) {
                    name = section.subtitle;
                }
            }
            return name;
        },
        activeTopSection() {
            if (this.isSearch || !this.topSections.length) return false;
            return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
        },

        activeSectionName() {
            let sectionsLock = this.sectionsLock.find(item => item.id === this.$route.params.subid);
            if (sectionsLock) {
                return sectionsLock.name;
            }
            
            if (!this.isLoadSections && Array.isArray(this.sections)) {
                if (this.$route.params.subid) {
                    const result = findSectionById(this.sections, this.$route.params.subid);
                    if (result) {
                        return result.parentSection ? result.parentSection.name : result.section.name;
                    }
                } else if (this.sections[0]) {
                    return this.sections[0].name;
                }
            } else if (this.isLoadSections) {
                return this.activeTopSectionSubSectionName;
            }
            
            return '';
        },

        activeSubSectionName() {
            let activeId = this.$route.params.subid || this.getActiveSection();;
            let sectionsLock = this.sectionsLock.find(item => item.id === activeId);
            if (sectionsLock) {
                return '';
            }
            
            if (!this.isLoadSections && Array.isArray(this.sections) && activeId) {

                const result = findSectionById(this.sections, activeId);
                if (result && result.parentSection) {
                    return result.section.name;
                }
            }
            
            return '';
        },

        activeSubSection() {
            if (this.$route.params.subid && !this.isRemovedPage) {
                return this.$route.params.subid;
            } else if (this.sections[0] && !this.isRemovedPage) {
                return this.sections[0].id;
            } else {
                return '';
            }
        },
        isAddRule() {
            let sections = this.sectionsLock.find(item => item.id == this.activeSubSection)
            return !!sections && this.user.access_rights.is_owner || !sections;
        },
    subSectionId() {
    if (!this.$route.params.id) return true;
    if (!this.$route.params.subid || !this.sections) return true;
    
    const result = findSectionById(this.sections, this.$route.params.subid);
    
    return result || false;
},
        is404() {
            let is404 = false;

            if (this.isNotFoundRule()) {
                is404 = true;
            }
            //пробуем получить данные, чтобы вызвать ошибку доступа, можно и без запроса, но так надёжнее
            //пока без запроса так
            let noSuccess = false;
            if (typeof this.topSections[0] !== 'undefined') {
                if (!this.subSectionId && this.$route.params.id && typeof this.topSections[0].all !== 'undefined') {
                    if (typeof this.topSections[0].all[this.$route.params.id] !== 'undefined') {
                        if (this.$route.params.subid) {
                            if (typeof this.topSections[0].all[this.$route.params.id].find(id => id === this.$route.params.subid) !== 'undefined') {
                                noSuccess = true;
                            }
                            if (this.sectionsLock.find(item => item.id === this.$route.params.subid)) {
                                noSuccess = false;
                            }
                        } else {
                            noSuccess = true;
                        }
                    } else {
                        noSuccess = false;
                    }
                }

            }

            if (!is404) {
                is404 = (this.$route.name === 'page404' || !this.subSectionId) 
                    && !noSuccess 
                    && !this.isLoadItems 
                    && !this.isLoadSections 
                    && !this.sectionsLock.find(item => item.id === this.$route.params.subid);
            }

            return is404;

        },
        files: {
            get() {
                return this.$store.getters['rules/getItemFiles']
            },
            set(value) {
                this.$store.commit('rules/setItemFiles', {
                    items: value
                });
            }
        },
        isAddRuleShowed() {
            return this.popups.addRule.show
        },
        curTopSection() {
            if (!this.topSections[0]) return false;

            for (let i in this.topSections) {
                if (this.topSections[i].id == this.activeTopSection) {
                    return this.topSections[i];
                }
            }
        },
        isRemovedPage() {
            return this.$route.name == 'rules-removed';
        }
    },
    watch: {
    '$route.params.id': {
    immediate: true,
    handler(id) {
        if (!id || id === 'lock') return;
        if (!this.topSections.length) return;
        
        this.loadSectionsForId(id);
    }
},
topSections: {
    handler(val) {
        if (!val.length) return;
        const id = this.$route.params.id;
        if (!id || id === 'lock') return;
        
        this.loadSectionsForId(id);
    }
},
        activeSubSection(val, oldVal) {
            this.isChangeRule = true;
        },
        isLoadEditRule(val, oldVal) {
            if (!this.isLoadEditRule && this.popups.addRule.show && this.useShortcut) {
                setTimeout(() => {
                    this.setCursorPos();
                }, 1)
            }
        },
        '$route'(to, from) {
            this.$store.commit('popups/close', {name: this.popups.ruleDetail.name});
            if (document.querySelector('.rules')) {
                document.querySelector('.rules').style.opacity = ''
            }
            ;
        },
        catError(val, oldVal) {
            if (oldVal) {
                this.repeatCatError = true;
            }
        },
        activeSectionName(val, oldVal) {
            this.setCategoryTitle();
        },
    },
    methods: {
        loadSectionsForId(id) {
            const isTopSection = this.topSections.find(s => s.id == id);
            if (isTopSection) {
                this.$store.dispatch('rules/getSections', { id });
                return;
            }

            const topSection = this.topSections.find(s => 
                s.subsections && s.subsections.some(subId => subId == id)
            );
            if (topSection) {
                this.$store.dispatch('rules/getSections', { id: topSection.id });
            } else {
                // id не найден ни как топ-секция ни в subsections - грузим как есть
                this.$store.dispatch('rules/getSections', { id });
            }
        },
          getActiveSection() {
            if (this.isSearch) return false;
            
            if (this.$route.params.subid) return this.$route.params.subid;
            
            if (!this.sections || !this.sections.length) return null;
            
            const firstSection = this.sections[0];
            
            return (firstSection.sections && firstSection.sections.length > 0) 
                ? firstSection.sections[0].id 
                : firstSection.id;
        },
		giveCommand(command, commandName){

			//Проверка активной команды
			if(this.activeCommand == 'bullet_list' && commandName != 'bullet_list'){
				this.editor.commands.bullet_list();
			}else if(this.activeCommand == 'ordered_list' && commandName != 'ordered_list'){
				this.editor.commands.ordered_list();
			}else if(this.activeCommand == 'h1' && commandName != 'h1'){
				this.editor.commands.heading({ level: 2 });
			}else if(this.activeCommand == 'h2' && commandName != 'h2'){
				this.editor.commands.heading({ level: 3 });
			}else if(this.activeCommand == 'h3' && commandName != 'h3'){
				this.editor.commands.heading({ level: 4 });
			}else if(this.activeCommand == 'blockquote' && commandName != 'blockquote'){
				this.editor.commands.blockquote();
			}else if(this.activeCommand == 'commentBlock' && commandName != 'commentBlock'){
				this.editor.commands.commentBlock();
			}


			if( (typeof command) == 'function' ) { command() }

			if( command == 'h1'){
				this.editor.commands.heading({ level: 2 })
			}else if(command == 'h2'){
				this.editor.commands.heading({ level: 3 })
			}else if(command == 'h3'){
				this.editor.commands.heading({ level: 4 })
			}
		},
        selectedFilterRuleType() {
            this.$store.commit('rules/setFilterRuleType', this.filterType);
            this.fetchData();
        },
        ruleColor(i) {
            let classesColor = {
                    0: '--blank',
                    1: '--blank',
                    2: '--draft',
                    3: '--rule',
                    4: '--rule',
                    5: '--archive',
                    6: '--blank',
                },
                selected = 0;

            if (typeof classesColor[i] !== 'undefined') {
                selected = classesColor[i];
            }

            return selected;
        },
        ruleTypeName(i) {
            let name = '';
            if (typeof this.typesOptions[i] !== 'undefined') {
                name = this.typesOptions[i]['name'];
            }

            return name;
        },
        openRecover: function (item) {
            this.recoverItem = item;
            this.$store.commit('popups/open', {name: this.popups.recoverRule.name});
        },
        openRemoveRule: function (item) {
            this.$store.dispatch('rules/checkEditItem', this.item).then((result) => {
                if (result.status) {
                    this.$store.commit('popups/open', {name: this.popups.removeDisabled.name});
                } else {
                    if (this.isRemovedPage) {
                        this.$store.dispatch('rules/setEditItem', item).then(() => {
                            this.$store.commit('popups/open', {name: this.popups.removeRuleForever.name});
                        });
                    } else {
                        this.$store.dispatch('rules/setEditItem', item).then(() => {
                            this.$store.commit('popups/open', {name: this.popups.removeRule.name});
                        });
                    }
                }
            });

        },
        copyRule(e, item) {
            let text = process.env.VUE_APP_PATH_FRONT + "/rule/?id=" + item.id;
            let elem = e.target.classList.contains('i') ? e.target.parentElement : e.target;
            if (e.target.classList.contains('i')) {
                e.target.parentElement.classList.add('copied');
                setTimeout(function () {
                    e.target.parentElement.classList.remove('copied');
                }, 500);
            } else {
                e.target.classList.add('copied');
                setTimeout(function () {
                    e.target.classList.remove('copied');
                }, 500);
            }
            copyTextToClipboard(text);
        },
        exitWithoutSave: function () {
            this.closeAddRuleApply();
        },
        closeAddRuleApply: function () {
            this.$store.commit('rules/setSelectedSection', true);
            if (this.isSearchPrev) {
                this.$store.commit('rules/setIsSearch', true);
                this.$store.commit('rules/setIsSearchPrev', false);
                this.$store.dispatch('rules/getItems', {search: this.searchStr, reload: true});
                if (this.$router.history.current.fullPath !== '/') {
                    this.$router.push({path: '/'});
                }
            } else {
                if (this.item.id && !this.item.active) {
                    this.$router.push('/removed/');
                } else if (this.item.id && this.item.active) {
                    if (this.$route.path != '/sid' + this.item.sectionTop + '/sub' + this.item.section + '/') {
                        if (this.item.sectionTop != this.item.section) {
                            this.$router.push('/sid' + this.item.sectionTop + '/sub' + this.item.section + '/');
                        } else if (this.previousSection.top.id) {
                            this.$router.push('/sid' + this.previousSection.top.id + '/sub' + this.item.sectionTop + '/');
                        }

                    }

                } else if (this.previousSection.top.id && this.previousSection.second.id) {
                    if (this.$route.path != '/sid' + this.previousSection.top.id + '/sub' + this.previousSection.second.id + '/') {
                        this.$router.push('/sid' + this.previousSection.top.id + '/sub' + this.previousSection.second.id + '/');
                    }
                }
            }
            this.$store.commit('popups/close', {name: this.popups.addRule.name});
            this.$store.commit('rules/setUseShortcut', false);
        },
        closeAddRule: function () {
            if (this.isChangeRule && (this.user.access_rights.is_owner || this.user.access_rights.is_tech_writer)) {
                this.$store.commit('popups/open', {name: this.popups.exitWithoutSave.name});
            } else {
                this.closeAddRuleApply();
            }
        },
        setCursorPos() {
            var range = document.createRange();
            var sel = window.getSelection();

            let current = document.querySelector('.ProseMirror');
            this.cursorPositionObj.path.forEach(index => {
                current = current.childNodes[index];
            });

            range.setStart(current, this.cursorPositionObj.offsetX);
            range.collapse(true);
            document.documentElement.scrollTop = this.cursorPositionObj.scrollTop - 30;
            sel.removeAllRanges();
            sel.addRange(range);
        },
        isRemovedRule() {
            let isRemovedRule = false;

            function getCookie(name) {
                let matches = document.cookie.match(new RegExp(
                    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
                ));
                return matches ? decodeURIComponent(matches[1]) : undefined;
            }

            let ruleId = window.location.hash.replace('#', ''),
                ruleStatus = getCookie('ruleStatus_' + ruleId),
                isTestRemoved = window.localStorage.getItem('isTestRemoved');
            if (ruleStatus === 'removed' || ruleStatus === 'basket' || isTestRemoved === 'true') {
                isRemovedRule = true;
            }

            return isRemovedRule;
        },
        isNotFoundRule() {
            let isRemovedRule = false;

            function getCookie(name) {
                let matches = document.cookie.match(new RegExp(
                    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
                ));
                return matches ? decodeURIComponent(matches[1]) : undefined;
            }

            let ruleId = window.location.hash.replace('#', ''),
                ruleStatus = getCookie('ruleStatus_' + ruleId),
                isTestRemoved = window.localStorage.getItem('isTestNotFoundRemoved');
            if (ruleStatus === 'error' || isTestRemoved === 'true') {
                isRemovedRule = true;
            }

            return isRemovedRule;
        },
        setLinkUrl(command) {
            command.link({href: this.link.value ? this.link.value : null, target: '_blank'});
            this.link.value = '';
            this.$store.commit('popups/close', {name: this.popups.addLink.name});
        },
        clearLinkUrl(command) {
            command.link({href: null, target: '_blank'});
            this.link.value = '';
            this.$store.commit('popups/close', {name: this.popups.addLink.name});
        },
        openAddLinkPopup(attr) {
            this.screenShotLink.value = '';
            if (attr && attr.detail && attr.detail !== 1) {
                this.link.value = attr.detail;
            }
            this.$store.commit('popups/open', {name: this.popups.addLink.name});
        },
        saveLoading(load) {
            this.save.btnType = load;
            if (load == 'ok') {

            }
        },
        openSearchField: function () {
            setTimeout(() => {
                let searchFieldInput = document.getElementById('searchFieldInput');
                this.$store.commit('rules/openSearchField', true);
                searchFieldInput.focus();
            }, 100);
        },
        scrollToUp() {
            scrollTo('up');
        },
        setScrollId(id, newID) {
            this.scrollID = id;
            this.newScrollID = newID;
        },
        scrollToElement() {
            this.$nextTick(() => {
                let id;
                if (this.scrollID && this.scrollID != 'new') {
                    id = 'rule' + this.scrollID;
                } else if (this.scrollID == 'new') {
                    id = document.querySelector('.rules').lastElementChild.id;
                }
                if (!document.getElementById(id) && this.tryScroll < 5) {
                    this.tryScroll++;
                    setTimeout(() => {
                        this.scrollToElement();
                    }, 100);

                } else {
                    if (this.scrollID) {
                        if (this.scrollID && this.scrollID != 'new') {
                            if (document.getElementById(id)) {
                                let items = this.$store.getters['rules/getItems'];
                                let idx = items.findIndex(el => el.id == this.scrollID);
                                let item = items.find(el => el.id == this.scrollID);
                                if (!this.backToList) {
                                    this.$store.commit('rules/toggleRule', idx);
                                    this.$store.dispatch('popups/open', {name: this.popups.ruleDetail.name});
                                }
                            }

                        } else if (this.scrollID == 'new') {
                            id = document.querySelector('.rules').lastElementChild.id;
                            let items = this.$store.getters['rules/getItems'];
                            let idx = this.newScrollID? items.findIndex(el => el.id == this.newScrollID) : 0; // Индекс ставится либо новго элемента, либо первого элемента
                            let item = items[idx];

                            this.$store.dispatch('rules/getRuleText', {item: item, index: idx}).then(() => {
                                if (!this.scrollID || this.scrollID == 'new') {
                                    this.$store.commit('rules/toggleRule', idx);
                                    this.$store.dispatch('popups/open', {name: this.popups.ruleDetail.name});
                                    this.$store.commit('rules/setOpenedRule', idx);
                                }
                                this.$store.dispatch('rules/deleteMarks', {id: this.scrollID});
                            });
                        }
                        // if(this.backToList){
                        //   scrollTo('#' + id);
                        //   this.backToList = false;
                        // }
                    }
                    this.scrollID = false;
                    this.tryScroll = 0;
                }

            })
        },
        removeContent() {
            this.isChangeRule = false;
            this.editor.setContent('');
        },
        divFocus() {
            this.focused = true;
        },
        back(isRoute) {
            if (document.querySelector('.rules')) {
                document.querySelector('.rules').style.opacity = ''
            }
            this.backToList = true;
            if (!this.isRemovedPage && !this.isSearch) {
                if(isRoute && this.$route.params.ruleid){
                    this.$router.push('/sid' + this.rule.sectionTop + '/sub' + this.rule.section + '/');
                }
            } else if (this.isRemovedPage) {
                this.$router.push('/removed').catch(() => {
                });
            }
            this.$store.commit('popups/close', {name: this.popups.ruleDetail.name});
            let id = 'rule' + this.rule.id;
            this.scrollID = this.rule.id;
            this.setCategoryTitle();
            setTimeout(() => {
                document.documentElement.scrollTop = this.scrollTop;
            });
            setTimeout(() => {
                if (document.getElementById(id)) {
                    document.getElementById(id).classList.add('highligth');
                }
            }, 10);
            setTimeout(() => {
                if (document.getElementById(id)) {
                    document.getElementById(id).classList.remove('highligth');
                }
            }, 500);
        },
        divBlur() {
            this.focused = false;
        },
        divInput(e) {
            if (this.inputText != e) {
                this.isChangeRule = true;
            }
            this.inputText = e;
        },
        pasteEditor(event) {
            let items = (event.clipboardData || event.originalEvent.clipboardData).items;
            let files = [];
            let isMixPaste = false;
            let text = false;
            for (let index in items) {
                let item = items[index];
                if ((item.kind == 'string') && (item.type.match('^text/plain'))) {
                    isMixPaste = true;
                } else if ((item.kind == 'string') && (item.type.match('^text/html'))) {
                    item.getAsString((s) => {
                        //console.log(s)
                    });
                    isMixPaste = true;
                } else if ((item.kind == 'string') && (item.type.match('^text/uri-list'))) {
                    item.getAsString((s) => {
                    });
                    isMixPaste = true;
                } else if ((item.kind == 'file')) {
                    let blob = item.getAsFile();
                    files.push(blob);

                }
            }
            if (!isMixPaste && files) {
                this.onFileAppend(this.editor.commands, files);
                event.preventDefault();
            }

            return true;
        },
        openEditRule: function (item) {
            this.$store.commit('rules/setIsEdit', true);
            this.backToList = false;
            this.$emit('openeditrule')
            if (this.isSearch) {
                this.$store.commit('rules/setIsSearch', false);
                this.$store.commit('rules/setIsSearchPrev', true);
            } else {
                this.$store.commit('rules/setPreviousSection', {
                    topSection: this.activeTopSection,
                    section: this.activeSection
                });
            }

            if (this.$route.path !== '/sid' + item.sectionTop + '/sub' + item.section + '/' && item.sectionTop != item.section && !this.$route.params.ruleid) {
                this.$router.push('/sid' + item.sectionTop + '/sub' + item.section + '/');
            }

            //очистка от <span class="query"></span>
            let tmpDiv = document.createElement("div");
            tmpDiv.innerHTML = item.name;
            item.name = tmpDiv.innerText;

            if (!item.isCheckEdit) {
                let timeout = setTimeout(() => {
                    this.$store.commit('rules/setCheckEditLoader', {id: item, value: true});
                }, 500)

                this.$store.commit('rules/setLoadItems', true);
                this.$store.dispatch('rules/checkEditItem', item).then((result) => {
                    if (result.status) {
                        this.$store.commit('rules/setLoadItems', false);
                        this.$store.commit('popups/open', {name: this.popups.editDisabled.name});
                    } else {
                        if (this.$route.name == 'rules-removed') {
                            this.$router.push('/sid' + item.sectionTop + '/sub' + item.section + '/');
                        }

                        this.$store.dispatch('rules/setEditItem', item).then(() => {
                            this.$store.dispatch('popups/open', {name: this.popups.addRule.name});
                        })
                        document.documentElement.scrollTop = 0;
                    }
                    clearTimeout(timeout);
                    this.$store.commit('rules/setCheckEditLoader', {id: item, value: false});
                }, () => {
                    this.$store.commit('rules/setCheckEditLoader', {id: item, value: false});
                }).catch(() => {
                    this.$store.commit('rules/setCheckEditLoader', {id: item, value: false});
                })
            }

        },
        openAddRule: function () {
            this.backToList = false;
            this.isChangeRule = false;
            this.$store.commit('rules/setOpenRule', {});
            this.$store.dispatch('rules/setEditItem', []).then(() => {
                this.$store.dispatch('popups/open', {name: this.popups.addRule.name});
                this.$store.commit('popups/close', {name: this.popups.ruleDetail.name});
                this.$store.commit('rules/setPreviousSection', {
                    topSection: this.activeTopSection,
                    section: this.activeSubSection
                });
                this.$store.commit('rules/setIsEdit', false);
            })
            document.documentElement.scrollTop = 0;
        },
        openRemoveRules: function () {
            this.$store.dispatch('popups/open', {name: this.popups.removeRules.name});
        },
        resetSearch: function () {
            this.search = '';
            this.fetchData();
        },
        fetchData() {
            this.$store.dispatch('rules/getItems', {
                id: this.activeSubSection,
                ruleType: this.filterRuleType.value,
                topSect: this.activeTopSection,
                search: this.search,
                reload: true
            });
        },
        toggleRoll() {
            this.$store.commit('rules/toggleRolled');
        },
        toggleDrag() {
            this.$store.commit('rules/toggleDrag');
        },
        getExt: function (name) {
            let parts;
            return (parts = name.split(".")).length > 1 ? parts.pop().toLowerCase() : "";
        },
        onFileAppendEvent(command, e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.onFileAppend(command, files);

        },
        onSchemaAppendEvent(command, e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.onSchemaFileAppend(command, files);

        },
        onSchemaFileAppend: function (command, files) {
            if (!files.length)
                return;
            let error = false;
            for (let i in files) {
                if (!files[i].size) {
                    continue;
                }
                let ext = this.getExt(files[i].name);

                if (!(files[i].size < 10 * 1024 * 1024 && (ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'svg'))) {
                    error = true;
                }
            }
            if (error) {
                this.$store.commit('popups/open', {name: this.popups.errorSchemeUpload.name});
            } else {
                this.loadFiles = true;

                for (let f in files) {
                    let filesId = [];
                    if (!files[f].size) {
                        continue;
                    }
                    let params = {};
                    let formData = new FormData();
                    formData.append('type', 'uploadFiles');
                    formData.append('isSchemeImage', 'Y');
                    formData.append('files_' + f, files[f]);
                    let id = Math.random().toString(36).substr(2, 9);
                    filesId.push({
                        id: id
                    })
                    command.image_preloader({'data-id': id})
                    params.formData = formData;

                    this.$store.dispatch('rules/uploadFiles', params).then((f) => {
                        this.loadFiles = false;
                        for (let i in f) {
                            if (f[i].path) {
                                let ext = this.getExt(f[i].name);
                                let preload = filesId[i] ? filesId[i].id : false;
                                command.schema({
                                    'data-href': this.appPath + '/' + f[i].path,
                                    'data-id': f[i].id,
                                    'data-type': ext,
                                    'preload': preload
                                })
                            }
                        }
                    });
                }

            }

        },
        getRights(item) {
            let section = this.topSections.find(sect => sect.id === item.sectionTop),
                rights = 'R';

            if (typeof (section) !== 'undefined') {
                rights = section.rights;
            }

            return rights;
        },
        onFileAppend: function (command, files) {
            if (!files.length)
                return;
            let error = false;
            for (let i in files) {
                if (!files[i].size) {
                    continue;
                }
                let ext = this.getExt(files[i].name);

                if (!(files[i].size < 10 * 1024 * 1024 && (ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'doc' || ext === 'docx' || ext === 'pdf' || ext === 'xls' || ext === 'xlsx'))) {
                    error = true;
                }
            }

            if (error) {
                this.$store.commit('popups/open', {name: this.popups.errorScreenUpload.name});
            } else {
                this.loadFiles = true;

                for (let f in files) {
                    let filesId = [];
                    if (!files[f].size) {
                        continue;
                    }
                    let params = {};
                    let formData = new FormData();
                    formData.append('type', 'uploadFiles');
                    formData.append('files_' + f, files[f]);
                    let id = Math.random().toString(36).substr(2, 9);
                    filesId.push({
                        id: id
                    })
                    command.image_preloader({'data-id': id})
                    params.formData = formData;

                    this.$store.dispatch('rules/uploadFiles', params).then((f) => {
                        this.loadFiles = false;
                        for (let i in f) {
                            if (f[i].path) {
                                let ext = this.getExt(f[i].name);
                                let preload = filesId[i] ? filesId[i].id : false;
                                if (ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'svg') {
                                    command.screenshot({
                                        'data-href': process.env.VUE_APP_PATH_BACK + '/' + f[i].path,
                                        'data-id': f[i].id,
                                        'data-small': process.env.VUE_APP_PATH_BACK + '/' + f[i].small,
                                        'preload': preload
                                    })
                                } else {
                                    command.other_file({
                                        'data-href': process.env.VUE_APP_PATH_BACK + '/' + f[i].path,
                                        'data-id': f[i].id,
                                        'data-type': ext,
                                        'preload': preload
                                    })
                                }
                            }
                        }
                    });
                }

            }

        },
        ruleSend(data) {
            this.catError = false;

            if (data.autoSave) {
                if (this.isChangeRule) {

                    if (!this.hasSelectedSection) {
                        setTimeout(() => {
                            this.catError = true;
                        });
                    }
                    this.$refs.addRule.send(true);

                }

                this.$store.commit('popups/close', {name: this.popups.ruleDetail.name});

                setTimeout(() => {
                    window.location.reload();
                }, 2000);

            } else {
                if (this.isChangeRule) {
                    this.$store.commit('popups/close', {name: this.popups.ruleDetail.name});

                    if (!this.hasSelectedSection) {
                        setTimeout(() => {
                            this.catError = true;
                        });
                    }
                    this.$refs.addRule.send(true);

                }
            }

        },
        openEditAdminDisabled: function () {
            this.$store.dispatch('popups/open', {name: this.popups.editAdminDisabled.name});
        },
        openRuleCategory: function () {
            this.$store.dispatch('popups/open', {name: this.popups.ruleCategory.name});
        },
        openAddScreenShotPopup() {
            this.screenShotLink.value = '';
            this.$store.commit('popups/open', {name: this.popups.addScreenShot.name});
        },

        openAddVideoPopup() {
            this.screenShotLink.value = '';
            this.$store.commit('popups/open', {name: this.popups.addVideo.name});
        },
        getYoutubeVideoId(url) {
            let youtubeMatch = url.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/);
            if (youtubeMatch) {
                return youtubeMatch;
            }
            return null;
        },
        getVkVideoId(url) {
            const extPattern = /^https:\/\/(?:vk\.com|vkvideo\.ru)\/video_ext\.php/;

            const videoPattern = /video(-?[0-9]+)_([0-9]+)/;

            if (extPattern.test(url)) {
                return url;
            }

            let match = url.match(videoPattern);

            if (match) {
                const [_, oid, id] = match;
                return `https://vk.com/video_ext.php?oid=${oid}&id=${id}&hd=2&autoplay=1`;
            }

            return false;
        },
        addScreenShot(command) {
            if (this.screenShotLink.value == '' || this.screenShotLink.value != '' && this.screenShotLink.value.match(/prntscr\.com|yadi\.sk|prnt\.sc|youtu(?:be\.com\/watch\?v=|\.be\/)|vk\.com\/video|vkvideo\.ru/) === null) {
                this.screenShotLink.error = true;
            } else {
                let ids = this.getYoutubeVideoId(this.screenShotLink.value) || this.getVkVideoId(this.screenShotLink.value);
                if (ids && ids[1]) {
                    let id = this.getVkVideoId(this.screenShotLink.value) ? this.getVkVideoId(this.screenShotLink.value) : ids[1];
                    let videoType = this.getVkVideoId(this.screenShotLink.value) ? 'vk' : 'youtube';
                    command.youtube({'data-id': id, 'data-type': videoType});
                    this.$store.commit('rules/addFile', {id: id, mediaType: 'video'});
                    this.$store.commit('popups/close', {name: this.popups.addVideo.name});
                    this.screenShotLink.value = '';
                    this.screenShotLink.btnType = 'normal';
                } else {
                    this.screenShotLink.btnType = 'load';
                    this.$store.dispatch('rules/addScreenShot', {value: this.screenShotLink.value}).then((src) => {
                        this.screenShotLink.btnType = 'ok';
                        if (src.path) {
                            command.screenshot({
                                'data-href': this.appPath + '/' + src.path,
                                'data-id': src.id,
                                'data-small': this.appPath + '/' + src.small
                            })
                        }
                        setTimeout(() => {
                            this.$store.commit('popups/close', {name: this.popups.addScreenShot.name});
                            this.screenShotLink.value = '';
                            this.screenShotLink.btnType = 'normal';
                        }, 200);
                    });
                }

            }
        },
        openInput: function () {
            this.$refs.fileInput.click();
        },
        openInputSchema: function () {
            this.$refs.fileInputSchema.click();
        },
        keyUp: function (e) {
            document.scrollTop = 100;
            if (e.keyCode === 8 && this.popups.ruleDetail.show && !this.popups.addRule.show) {
                this.back();
            }
        },
        setScreencast() {
            this.$store.dispatch('rules/setScreencast', {id: this.rule.id, value: this.tumblers.screencast.value});
        },
        setCategoryTitle() {
            document.title = `${this.activeTopSectionName.toUpperCase()} / ${this.activeSectionName.toUpperCase()}`;
        },
    },
    mounted() {
        this.$store.subscribe((mutation, state) => {
            if (mutation.type == 'rules/setIsSearch') {
                if (state.rules.isSearch === false) {
                    this.search = '';
                }
            }
            if (mutation.type == 'rules/setItems') {
                this.scrollToElement();
            }
        });

        document.addEventListener('keyup', this.keyUp);
        document.addEventListener('openlinkedit', this.openAddLinkPopup);
    },
    beforeDestroy() {
        document.removeEventListener('keyup', this.keyUp);
        document.removeEventListener('openlinkedit', this.openAddLinkPopup);
        document.title = 'РЕГЛАМЕНТЫ И ПРАВИЛА';
    }
}
</script>
<style>

</style>
